module.exports = __webpack_public_path__ + "img/jiangchenghong.fdb9d3c9.jpg";